
import urlbase from './baseIp.js';
const URL = urlbase;
const prefix = URL + '/pick/';
const prefix1 = URL + '/wanhua/edi/odQuery';
const prefix2 = URL +'/task/pushTask';
const prefix3 = URL + '/task/insertWms';
const prefix4 = URL + '/wms/getWmsBatchNos';
const prefix5 =  URL +'/task/assignBatchs';
const prefix6 = URL + '/wanhua/edi/getLmsInfo';
const prefix7 = URL +'/task/getCkNote';
const prefix8 = URL + '/task/getAssignResult';
const prefix9 = URL + '/task/deleteAssign';
const prefix10 =URL +'/task/mergePush/';
const prefix11 =URL +'/task/';
const prefix_carTasks =URL +'/carTasks';
const prefix_template =URL +'/template';
const prefix_baseInfo =URL +'/baseInfo';
const prefix_carTaskReport =URL +'/carTaskReport';





const url2 = {
    receiveImg: prefix11 + 'receiveImg',
    findTask: prefix + 'findTask',
    getDetailById: prefix + 'find/getDetailById',
    odQuery: prefix1,
    pushTask:prefix2,
    insertWms:prefix3,
    getBatchNos:prefix4,
    assignBatchs:prefix5,
    getLmsInfo:prefix6,
    getCkNote:prefix7,
    getAssignResult:prefix8,
    deleteAssign:prefix9,
    mergePush:prefix10,
    // 获取调度任务
    getCarList:prefix_carTasks + '/getCarList',
    // 修改任务状态
    changeStatus:prefix_carTasks + '/changeStatus',
    // 根据id查询详细信息
    getCarTaskDetail:prefix_carTasks + '/getCarTaskDetail',
    // 查详细地址带出联系人和电话
    getAddressBy:prefix_carTasks + '/getAddressBy',
    // 根据货物名称查询出货物
    getGoodBy:prefix_carTasks + '/getGoodBy',
    // 获取司机运费表
    getTemplate: prefix_template + '/getTemplate',
    // 根据id查运费表详情
    getTemplateDetailById: prefix_template + '/getTemplateDetailById',
    // 删除运费表中明细
    deleteOneRecord: prefix_template + '/deleteOneRecord',
    // 保存运费方案
    saveOrUpdateTemplate: prefix_template + '/saveOrUpdateTemplate',
    // 根据起始地、目的地计算司机运费
    getAmountByConditions: prefix_template + '/getAmountByConditions',
    // 获取陆运站点名称
    getPort: prefix_baseInfo + '/getPort',
    // 获取司机列表
    getDriverByName: prefix_baseInfo + '/getDriverByName',
    // 运输任务指派司机
    setDriver: prefix_carTasks + '/setDriver',
    // 司机工资表
    getSalaryList: prefix_carTaskReport + '/getSalaryList',
}
export default url2